// PDF は preview を挟まず新しいタブで開く (ブラウザの PDF 表示に任せる。1 手)。
// この画面は COEP (credentialless。ffmpeg.wasm のため) の下にあり、別 origin の PDF を iframe に出せない
// (手元で確認) こともあり、埋め込みは持たない (design-book 02-components/attachments-panel.md)。
export const openPdf = (url: string) => {
  window.open(url, '_blank', 'noopener')
}
